export default __webpack_public_path__ + "static/AtlasInPyBullet-fab1ac60d93a1ab032debfea9ad07614.png";